import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modalpopup"
}
const _hoisted_2 = {
  class: "modal",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog classic-modal-dialog" }
const _hoisted_4 = { class: "modal-content classic-modal-content display-flex" }
const _hoisted_5 = { class: "classic-left-panel width33 color-white" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "classic-right-panel width65 position-relative" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "display-flex margin-top-20 margin-bottom-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modalPopUp && _ctx.modalPopUp.IsVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      class: "classic-logo margin-bottom-30",
                      src: _ctx.logoUrl,
                      alt: "Ventla"
                    }, null, 8, _hoisted_6),
                    _createElementVNode("div", {
                      innerHTML: _ctx.modalPopUp.LeftPanelContent
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "classic-close position-absolute",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Close()))
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", {
                        class: "fa fa-times close-color",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))]),
                    _createElementVNode("div", {
                      innerHTML: _ctx.modalPopUp.RightPanelContent
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.modalPopUp.Button1Text)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary btn-size-default margin-right-10",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Button1Click()))
                          }, _toDisplayString(_ctx.modalPopUp.Button1Text), 1))
                        : _createCommentVNode("", true),
                      (_ctx.modalPopUp.Button2Text)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-secondary btn-size-default",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Button2Click()))
                          }, _toDisplayString(_ctx.modalPopUp.Button2Text), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.modalPopUp.ContinueButtonText)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "hyperlink",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ContinueClick()))
                        }, _toDisplayString(_ctx.modalPopUp.ContinueButtonText), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}